<template>
  <div class="day-status">
    <button role="switch" :aria-checked="complete" :disabled="saving || loading" @click="save">
      <span class="track" :class="{ on: complete }" aria-hidden="true"><span /></span>
      <span class="caption">Полный день</span>
    </button>
    <span v-if="error" class="error" role="alert">Не сохранено</span>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue'
import api from '../services/api.js'

const props = defineProps({
  date: { type: String, required: true },
  kcal: Number,
  tz: { type: String, required: true },
})
const emit = defineEmits(['changed'])
const complete = ref(false), loading = ref(true), saving = ref(false), error = ref(false)
let serial = 0

watch(() => [props.date, props.kcal, props.tz], async () => {
  const n = ++serial
  loading.value = true
  error.value = false
  try {
    const { data } = await api.get('/diary/day-status', { params: { date: props.date, tz: props.tz } })
    if (n === serial) complete.value = data.complete
  } catch {
    if (n === serial) error.value = true
  } finally {
    if (n === serial) loading.value = false
  }
}, { immediate: true })

async function save() {
  const date = props.date
  saving.value = true
  error.value = false
  try {
    const { data } = await api.put('/diary/day-status', { date, complete: !complete.value, tz: props.tz })
    if (date === props.date) complete.value = data.complete
    emit('changed', data)
  } catch {
    error.value = true
  } finally {
    saving.value = false
  }
}
</script>
<style scoped>
.day-status { display:flex; flex-direction:column; align-items:flex-start; color:var(--ink-70); font-family:Inter,sans-serif; }
.caption { font-size:var(--fs-13); line-height:1.4; }
button { display:flex; align-items:center; gap:8px; min-height:44px; }
button:focus-visible { outline:2px solid var(--ink-50); outline-offset:3px; border-radius:8px; }
button:disabled { opacity:.5; }
.track { flex:none; width:38px; height:22px; border-radius:99px; background:var(--ink-20); padding:3px; }
.track > span { display:block; width:16px; height:16px; border-radius:50%; background:#fff; transition:transform .15s; }
.track.on { background:var(--day-complete); }
.track.on > span { transform:translateX(16px); }
.error { color:var(--error); font-size:var(--fs-11); }
@media(prefers-reduced-motion:reduce){.track>span{transition:none}}
</style>
